import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import PaymentAccount from "../../payment-account/model/paymentaccount"
import IntlProps from "../../state/helpers/IntlProps"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { Metadata } from "../../state/payment-processor/metadata"
import Terminal from "../../state/terminal/Terminal"
import LoadingSpinner from "../spinner/loading.component"
import { messages } from "./messages"
import RainforestTerminalPayment from "./rainforest/RainforestTerminalPayment"

type OwnProps = {
    integrationKey: string,
    paymentAccount: PaymentAccount,
    terminals: Terminal[],
    amount: number,
    currency: string,
    disabled: boolean,
    proposalHash: string,
    contactId: string,
    buildMetaData: () => Metadata,
    onPresent: () => void,
    onCancel: () => void,
    onSuccess: () => void,
}

const TerminalPayment = (props: OwnProps & IntlProps) => {
    const [selectedTerminalId, setSelectedTerminalId] = useState<string | undefined>()
    const [isPresenting, setIsPresenting] = useState<boolean>(false)

    useEffect(() => {
        const defaultTerminal = props.terminals.filter(t => !t.isInUse())[0]

        if (defaultTerminal) {
            setSelectedTerminalId(defaultTerminal.getId())
        }
    }, [])

    const handlePresent = () => {
        setIsPresenting(true)
        props.onPresent()
    }

    const handleCancel = () => {
        setIsPresenting(false)
        props.onCancel()
    }

    const handleSuccess = () => {
        setIsPresenting(false)
        props.onSuccess()
    }

    const getIntegrationComponent = (): React.ReactElement => {
        switch (props.integrationKey) {
        case INTEGRATION_KEY.RAINFOREST:
            return (
                <RainforestTerminalPayment
                    paymentAccount={props.paymentAccount}
                    isPresenting={isPresenting}
                    terminalId={selectedTerminalId}
                    amount={props.amount}
                    currency={props.currency}
                    disabled={props.disabled}
                    proposalHash={props.proposalHash}
                    contactId={props.contactId}
                    buildMetaData={props.buildMetaData}
                    onPresent={handlePresent}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )
        default:
            return <LoadingSpinner />
        }
    }

    const hasAvailableTerminals = (): boolean => {
        return props.terminals.filter(t => !t.isInUse()).length > 0
    }

    const getTerminalLabel = (terminal: Terminal): string => {
        return `
            ${terminal.getName()} ${terminal.getBrandAndModel()} ${terminal.isInUse() ? "[" + props.intl.formatMessage(messages.inUse) + "]" : ""}
        `
    }

    return (
        <>
            <div className={"w-100 d-flex align-items-center py-2"}>
                <strong className="w-25">{props.intl.formatMessage(messages.selectionLabel)}</strong>
                <select
                    name="paymentType"
                    value={selectedTerminalId}
                    onChange={e => setSelectedTerminalId(e.target.value)}
                    id="paymentType"
                    className="form-control w-75"
                    disabled={props.disabled || isPresenting}
                >
                    {!hasAvailableTerminals() && (
                        <option value="" disabled selected>
                            {props.intl.formatMessage(messages.noAvailableTerminals)}
                        </option>
                    )}
                    {props.terminals.map(terminal => (
                        <option
                            key={terminal.getId()}
                            value={terminal.getId()}
                            disabled={terminal.isInUse()}
                        >
                            {getTerminalLabel(terminal)}
                        </option>
                    ))}
                </select>
            </div>
            {getIntegrationComponent()}
        </>
    )
}

export default injectIntl(TerminalPayment)



// WEBPACK FOOTER //
// ./src/common/terminal-payment/TerminalPayment.tsx